export const TIMEZONES: { [key: string]: string } = {
    1: "Eastern Standard Time",
    2: "Central Standard Time",
    3: "Mountain Standard Time",
    4: "Pacific Standard Time",
}